import React from 'react';
import { Helmet } from 'react-helmet';
import { Route, Switch } from 'react-router-dom';
import { domainMap, domainName } from '../config';
import { seoData } from '../global/seoData';
import AboutUs from '../pages/AboutUs/AboutUs';
import Contactus from '../pages/Contactus/Contactus';
import { default as HomePage, default as PostActivationHome } from '../pages/Home/AstoundHome';
import PostActivationAccount from '../pages/PostActivationPages/Account/AstoundAccount';
import Activation from '../pages/PostActivationPages/Activation/Activation';

import SecondaryUserHome from '../../src/pages/SecondaryUserHome/SecondaryUserHome';
import CoverageMap from '../pages/CoverageMap/CoverageMap';
import ActivateESim from '../pages/PostActivationPages/Activation/ActivateESim';
import PostActivationServices from '../pages/PostActivationPages/Services/AstoundServices';
import Privacy from '../pages/Privacy/Privacy';
import Profile from '../pages/Profile/Profile';
import Terms from '../pages/Terms/Terms';
import TrackOrder from '../pages/TrackOrder/TrackOrder';
import './routes.scss';

//NL
import { useSelector } from 'react-redux';
import ActivationStatus from '../components/ActivationStatusComponent/ActivationStatus';
import StaticSteps from '../components/Steps/StaticSteps';
import AstoundUserNotFound from '../pages/AstoundLogin/AstoundUserNotFound';
import AstoundLogin from '../pages/AstoundLogin/Astoundlogin';
import ActivationError from '../pages/PostActivationPages/Activation/ActivationError';
import Help from '../pages/PostActivationPages/Help/help';
import Settings from '../pages/PostActivationPages/Settings/settings';
import AstoundPreLogin from '../pages/PreLogin/PreLogin';
import SessionExpired from '../pages/SessionExpired/SessionExpired';
// import { CircularProgress } from '@material-ui/core';

const Routes: React.FC = () => {
    const configState = useSelector((state: any) => state.billing.config);
    // const ssoToken: any = localStorage.getItem('astoundAccessToken');
    return (
        <div className="mainRoutes">
            {domainName === domainMap.T2 ? (
                <Helmet>
                    <title>{seoData.earthHome.title}</title>
                </Helmet>
            ) : (
                <Helmet>
                    <title>{seoData.home.title}</title>
                    <meta name="description" content={seoData.home.description} />
                    <meta name="keywords" content={seoData.home.keywords} />
                </Helmet>
            )}
            {domainName === domainMap.T1 ? (
                // configState?.data?.configs || !ssoToken ? (
                <Switch>
                    <Route exact path="/help" component={Help} />
                    <Route exact path="/login" component={AstoundLogin} />
                    <Route exact path="/home" component={HomePage} />
                    <Route exact path="/user" component={AstoundUserNotFound} />
                    <Route exact path="/session-expired" component={SessionExpired} />
                    <Route exact path="/terms" component={Terms} />
                    <Route exact path="/privacy" component={Privacy} />
                    <Route exact path="/contact-us" component={Contactus} />
                    <Route exact path="/track-order" component={TrackOrder} />
                    <Route exact path="/about-us" component={AboutUs} />
                    <Route exact path="/post-activation-home" component={PostActivationHome} />
                    <Route exact path="/mobile-login" component={AstoundPreLogin} />
                    <Route exact path="/status" component={ActivationStatus} />
                    <Route exact path="/secondarylogin" component={SecondaryUserHome} />
                    <Route exact path="/account" component={PostActivationAccount} />
                    {configState?.data?.configs?.SERVICE_TAB === 'ENABLE' && (
                        <Route exact path="/services" component={PostActivationServices} />
                    )}
                    <Route exact path="/activation" component={Activation} />
                    <Route exact path="/coverage-map" component={CoverageMap} />
                    <Route exact path="/profile" component={Profile} />
                    <Route exact path="/activate-esim" component={ActivateESim} />
                    <Route exact path="/steps" component={StaticSteps} />
                    <Route exact path="/activation-error" component={ActivationError} />
                    <Route exact path="/settings" component={Settings} />
                    <Route path="/" component={AstoundLogin} />
                </Switch>
            ) : // ) : (
            //         <div
            //             style={{
            //                 marginTop: '20px',
            //                 display: 'flex',
            //                 justifyContent: 'center',
            //                 alignItems: 'center',
            //             }}
            //         >
            //             <CircularProgress />
            //         </div>
            //     )
            null}
        </div>
    );
};

export default Routes;
